import { connect } from 'react-redux';

import { isAnonShibbolethLogin } from '@Containers/Header/HeaderComponentSelectors';
import AnonymousUser from './AnonymousUser';

function mapStateToProps(state) {
  return {
    isAnonShibbolethLogin: isAnonShibbolethLogin(state),
  };
}

export default connect(mapStateToProps, null)(AnonymousUser);
